import { useMemo, useState } from "react";
import { artworks, categories } from "@/mocks/comic";

const qualityStyle: Record<string, string> = {
  "4K超清原图": "bg-primary-500 text-background-50",
  "超清原图": "bg-accent-500 text-background-50",
  "原图典藏": "bg-secondary-600 text-background-50",
};

export default function QualityGallery() {
  const [active, setActive] = useState("全部");
  const [liked, setLiked] = useState<number[]>([]);

  const list = useMemo(
    () =>
      active === "全部"
        ? artworks
        : artworks.filter((a) => a.category === active),
    [active],
  );

  const toggleLike = (id: number) => {
    setLiked((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  return (
    <section id="quality" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-vip-crown-2-line"></i>
              画质精选
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              高清原图 · 逐帧收藏
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              按画质精细筛选入库的高清静态漫画原图，支持分类浏览与画质档位识别，放大亦见细节。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 rounded-full bg-background-100 p-1.5">
            {categories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`rounded-full px-4 py-1.5 text-sm whitespace-nowrap transition-colors ${
                  active === c
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-50 hover:text-primary-600"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => {
            const isLiked = liked.includes(a.id);
            return (
              <article
                key={a.id}
                className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={a.image}
                    alt={`${a.title} - 静漫天堂漫画高清静态原图`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span
                    className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${
                      qualityStyle[a.quality] ?? "bg-primary-500 text-background-50"
                    }`}
                  >
                    {a.quality}
                  </span>
                  <span className="absolute right-3 top-3 rounded-full bg-black/45 px-2.5 py-1 text-xs whitespace-nowrap text-background-50 backdrop-blur-sm">
                    {a.category}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-medium text-foreground-950">
                    {a.title}
                  </h3>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-image-2-line"></i>
                      {a.size}
                    </span>
                    <div className="flex items-center gap-3">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {(a.views / 1000).toFixed(1)}k
                      </span>
                      <button
                        type="button"
                        aria-label={isLiked ? "取消喜欢" : "喜欢"}
                        onClick={() => toggleLike(a.id)}
                        className={`inline-flex items-center gap-1 transition-colors ${
                          isLiked
                            ? "text-primary-500"
                            : "text-foreground-600 hover:text-primary-500"
                        }`}
                      >
                        <i
                          className={
                            isLiked ? "ri-heart-fill" : "ri-heart-line"
                          }
                        ></i>
                        {isLiked ? a.likes + 1 : a.likes}
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}